<!-- En modalOnly (chips de pendientes de Análisis de Pedido / Inventario R/T)
     el panel completo se apaga: la instancia solo existe para los modales de
     respuesta de abajo. -->
<div class="card" *ngIf="!modalOnly">
    <div class="card-body">
        <!-- La card se ajusta al contenido (como la vista del solicitante): header +
             tabla de 15 filas + paginador. La tabla hace scroll INTERNO solo si el
             historial expandido supera las 15 filas (max-height en .orders-summary-scroll). -->
        <div class="dataTables_wrapper">
            <div class="row pipes-admin__head">
                <div class="col-sm-12 col-md-12">
                    <!-- Primera línea: título y, pegados a él, los filtros (revisión 06-oct) -->
                    <div class="pipes-admin__head-inner">
                        <h2 class="pipes-req__section-title">
                            Solicitudes de Pipas (MOBICO)
                            <!-- Excel de lo visible (pedido MOBICO 08-oct): junto al título, como en
                                 las demás secciones del flujo, para no partir la fila de filtros. -->
                            <button type="button" class="pipes-admin__excel" aria-label="Descargar Excel" *ngIf="reqst === 1"
                                pTooltip="Descargar solicitudes aprobadas (formato MOBICO)" tooltipPosition="top" [showDelay]="150" tooltipStyleClass="cap-tooltip"
                                [disabled]="!requests.length" (click)="exportRequestsExcel()">
                                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                            </button>
                        </h2>

                        <!-- En modo estación (página de estación) el panel queda fijo a la
                             estación seleccionada: solo se ofrece la semana, como en la
                             vista del solicitante. -->
                        <div class="pipes-admin__filters">
                            <!-- Buscador primero (revisión 06-oct): estación o PO, mismo
                                 control que Solicitudes/Cronograma del flujo. -->
                            <div class="select-station-filter pipes-admin__search" *ngIf="reqst === 1">
                                <i class="fa fa-search" aria-hidden="true"></i>
                                <input type="search" placeholder="Buscar estación o PO"
                                    aria-label="Buscar estación o PO" [(ngModel)]="ordersSearch"
                                    [ngModelOptions]="{ standalone: true }" (input)="onSearchChange()" />
                            </div>
                            <div class="select-type" *ngIf="rol === 'Dios' && reqst === 1 && !onlyStation">
                                <app-select-group></app-select-group>
                            </div>
                            <!-- Zona se ELIMINÓ de esta banda (task 2026-07-15, mismo criterio que
                                 la banda Solicitudes del solicitante desde 2026-07-09): sin columna
                                 de zona en la tabla y con el filtro de Estación, solo estorbaba.
                                 OJO: el componente ya NO se suscribe a sharedZone (ver constructor)
                                 para que una zona elegida en otra vista del Tablero no filtre esta
                                 tabla en silencio. -->
                            <div class="select-type-brand">
                                <!-- "Semana actual" en vez del rango (normalización 2026-07-13,
                                     mismo trato que Solicitudes; el value queda intacto) -->
                                <!-- periodOptions: la lista termina con "Mes actual" / "Mes anterior"
                                     (revisión 08-oct, un solo filtro); compartido con el Cronograma. -->
                                <app-select-week currentWeekLabel="Semana actual" [periodOptions]="true" [twoWeeksOption]="true" [multiWeeks]="true"></app-select-week>
                            </div>

                            <!-- Filtro por estación (buscable: se escribe el nombre y filtra) -->
                            <!-- Grupo: solo cuando lo cargado abarca más de uno
                                 (acuerdo junta 19-ago §5.2). El panel pide con
                                 all_groups, así que puede traer estaciones que no
                                 están en el dropdown de Estación. -->
                            <div class="select-station-filter" *ngIf="reqst === 1 && groupFilterOptions.length && !onlyStation">
                                <!-- noAutoComplete: sin buscador, para que el control mida
                                     lo mismo abierto que cerrado (son 2-3 grupos). -->
                                <ngx-select class="op-ngx-select" [allowClear]="false" [noAutoComplete]="true"
                                    [items]="groupFilterOptions" optionValueField="value" optionTextField="label"
                                    placeholder="Todos los grupos" [(ngModel)]="groupFilter"
                                    [ngModelOptions]="{ standalone: true }" (ngModelChange)="onGroupFilterChange()">
                                </ngx-select>
                            </div>
                            <!-- El dropdown de estación se quitó (Edey 19-oct): el buscador filtra por estación o PO. -->
                            <!-- Tipo · Respuesta MOBICO · Acciones (junta 19-oct): filtran lo que la fila muestra
                                 (su último estatus). noAutoComplete: listas cortas, el control mide igual abierto. -->
                            <div class="select-station-filter" *ngIf="reqst === 1">
                                <ngx-select class="op-ngx-select" [allowClear]="false" [noAutoComplete]="true"
                                    [items]="typeFilterOptions" optionValueField="value" optionTextField="label"
                                    placeholder="Todos los tipos" [(ngModel)]="typeFilter"
                                    [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFilterChange()">
                                </ngx-select>
                            </div>
                            <!-- Producto · Fecha requerida (junta 27-oct): ubicar las pipas de un día. -->
                            <div class="select-station-filter" *ngIf="reqst === 1">
                                <ngx-select class="op-ngx-select" [allowClear]="false" [noAutoComplete]="true"
                                    [items]="productFilterOptions" optionValueField="value" optionTextField="label"
                                    placeholder="Todos los productos" [(ngModel)]="productFilter"
                                    [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFilterChange()">
                                </ngx-select>
                            </div>
                            <div class="select-station-filter" *ngIf="reqst === 1">
                                <ngx-select class="op-ngx-select" [allowClear]="false" [noAutoComplete]="true"
                                    [items]="requiredDateFilterOptions" optionValueField="value" optionTextField="label"
                                    placeholder="Todas las fechas" [(ngModel)]="requiredDateFilter"
                                    [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFilterChange()">
                                </ngx-select>
                            </div>
                            <div class="select-station-filter" *ngIf="reqst === 1">
                                <ngx-select class="op-ngx-select" [allowClear]="false" [noAutoComplete]="true"
                                    [items]="responseFilterOptions" optionValueField="value" optionTextField="label"
                                    placeholder="Todas las respuestas" [(ngModel)]="responseFilter"
                                    [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFilterChange()">
                                </ngx-select>
                            </div>
                            <div class="select-station-filter" *ngIf="reqst === 1">
                                <ngx-select class="op-ngx-select" [allowClear]="false" [noAutoComplete]="true"
                                    [items]="actionFilterOptions" optionValueField="value" optionTextField="label"
                                    placeholder="Todas las solicitudes" [(ngModel)]="actionFilter"
                                    [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFilterChange()">
                                </ngx-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="reqst === 1">

                <!-- Tabla única "Solicitudes" (formato MOBICO): UNA fila por pedido, sin desglose
                     de historial. El Tipo y el estatus reflejan la solicitud en curso: el cambio en
                     vuelo si lo hay (Aprobar/Rechazar responden ese cambio), si no el pedido tal
                     cual. La columna Tipo usa el color de la sección del formato oficial. -->
                <!-- Sin paginación (pedido 2026-07-13): todos los pedidos bajo el
                     scroll interno, pintados por lotes conforme se baja (ver
                     onOrdersScroll — scroll infinito client-side). -->
                <div class="orders-summary-scroll" (scroll)="onOrdersScroll($event)">
                    <!-- trackByProp: SIN él ngx-datatable trackea por índice posicional y al
                         insertar/quitar filas de historial las clases se recorren entre
                         elementos DOM reusados → re-animaba filas que no cambiaron.
                         (rowIdentity NO alimenta el trackBy; es bookkeeping interno.) -->
                    <ngx-datatable class="bootstrap selection-cell orders-summary" [columnMode]="'force'"
                        [headerHeight]="50" [rowHeight]="32" [rows]="requests" [scrollbarV]="false" [scrollbarH]="false"
                        [rowClass]="getRowClass" [rowIdentity]="rowIdentity" [trackByProp]="'_id'"
                        [messages]="{emptyMessage: emptyRequestsMessage}">
                        <!-- minWidth: slot del caret (20px) + chip más largo ("Cambio de capacidad")
                             ≈ 156px; evita que force comprima la columna y corte los chips. -->
                        <ngx-datatable-column prop="type_label" name="Tipo" [width]="190" [minWidth]="190" [maxWidth]="205" [sortable]="false"
                            [cellClass]="'left-side green-gray'" [headerClass]="'left-side top-side green-gray'">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <!-- Slot fijo del caret: reserva el mismo ancho en todas las filas
                                     para que el chip quede alineado. El caret solo aparece en el pedido
                                     padre con historial; al expandir, sus filas se insertan debajo. -->
                                <!-- Chevron rotatorio (mecánica de acordeón): un solo ícono que gira
                                     90° al abrir, en lugar de intercambiar right/down sin transición. -->
                                <span class="oh-toggle-slot">
                                    <i class="fa fa-chevron-right oh-toggle" [class.open]="isHistoryOpen(row)"
                                        *ngIf="!row.is_history && row.has_history" title="Ver historial de la solicitud"
                                        aria-hidden="true" (click)="toggleHistory(row)"></i>
                                </span>
                                <span class="type-chip" [ngClass]="row.change_kind">{{ row.type_label }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="po_number" name="PO" [width]="poColWidth" [minWidth]="poColWidth" [sortable]="false" [headerClass]="'top-side'">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <!-- Fila del historial: el PO tal como estaba ANTES de ese cambio; si el pedido pasó a otro PO, el
                                     tooltip lo dice (el anterior ya no se reutiliza). La fila del pedido lleva el vigente. -->
                                <span [title]="poColumnTitle(row)">{{ row.po_number || '—' }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <!-- Orden de las primeras columnas (revisión 07-oct): Tipo · PO · Producto ·
                             Fecha de solicitud, igual que Solicitudes del solicitante y el Cronograma. -->
                        <ngx-datatable-column prop="material" name="Producto" [width]="110" [minWidth]="95" [maxWidth]="130" [sortable]="false" [headerClass]="'top-side'">
                            <!-- Chip de producto (revisión 06-oct): el mismo mobil-* de la
                                 tabla Solicitudes del solicitante. El material solo se
                                 agrega si es uno real: cuando falta, rows/normalize lo
                                 rellenan con el nombre del producto y saldría repetido. -->
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="material-with-product">
                                    <span class="product-chip" *ngIf="row.product" [ngClass]="'mobil-' + row.product">{{ productLabel(row.product) }}</span>
                                    <span class="material-cell" *ngIf="!row.product || (row.material && row.material !== productLabel(row.product))"
                                        [title]="row.material || ''">{{ row.material || '—' }}</span>
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <!-- Fecha de solicitud = cuándo se creó (timestamp real → hora de México).
                             Encabezado en una línea (nowrap del header modernizado); la columna se
                             ensancha para que el texto completo quepa. -->
                        <ngx-datatable-column prop="request_date" name="Fecha de solicitud" [width]="105" [minWidth]="100" [sortable]="false" [headerClass]="'top-side'">
                            <ng-template ngx-datatable-header-template><span>Fecha de<br />solicitud</span></ng-template>
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.request_date ? (row.request_date | date:'dd/MM/yy':'-0600':'es') : '—' }}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="order_delivery_date" name="Fecha requerida" [width]="105" [minWidth]="100" [sortable]="false" [headerClass]="'top-side'">
                            <ng-template ngx-datatable-header-template><span>Fecha<br />requerida</span></ng-template>
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.order_delivery_date ? (row.order_delivery_date | date:'dd/MM/yy':'+0000':'es') : '—' }}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="station_name" name="Estación" [width]="stationColWidth" [minWidth]="stationColWidth" [sortable]="false" [headerClass]="'top-side'">
                            <!-- "Dispensario" (revisión 14-oct): abre la vista de ESA estación, el mismo
                                 ícono de las tablas del solicitante. Desde Solicitudes va a la vista de
                                 estación de Solicitud de pipas (Edey 15-oct), no al Monitor. -->
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <i class="mdi mdi-gas-station stn-go" *ngIf="gasprecioService.canOpenPipesStation(row.station_id)"
                                    title="Ir a la estación" (click)="gasprecioService.openPipesStation(row.station_id, '/gasprecio/solicitud-pipas')"></i>{{ row.station_name || '—' }}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="truck_capacity" name="Capacidad" [width]="100" [minWidth]="95" [sortable]="false" [headerClass]="'top-side'">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <!-- pTooltip (no el title nativo): aparece al instante, con estilo propio y
                                     se adjunta al body, así la tabla no lo recorta -->
                                <span class="cap-cell" [pTooltip]="capacityTooltip(row)" tooltipPosition="top"
                                    [showDelay]="150" tooltipStyleClass="cap-tooltip">
                                    {{ capacityValue(row) != null ? (capacityValue(row) | number:'1.0-0') : '—' }}
                                    <i *ngIf="showCapacityDiff(row)" class="fa fa-info-circle cap-info" aria-hidden="true"></i>
                                    <!-- Aviso de capacidad (junta 27-oct): ámbar = la siguiente capacidad ya no cabe en el
                                         tanque ese día; rojo = ya no cabe. El detalle va en el mismo tooltip. -->
                                    <i *ngIf="row._capRisk" class="fa fa-exclamation-triangle cap-risk" [class.over]="row._capRisk.level === 'over'"
                                        role="img" [attr.aria-label]="row._capRisk.level === 'over' ? 'Ya no cabe en el tanque' : 'Poco espacio en el tanque'"></i>
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <!-- Valor nuevo solicitado (solo cuando hay un cambio en curso; '—' si no) -->
                        <ngx-datatable-column prop="new_value" name="Nuevo valor" [width]="95" [minWidth]="85" [sortable]="false" [headerClass]="'top-side'">
                            <ng-template ngx-datatable-header-template><span>Nuevo<br />valor</span></ng-template>
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <!-- Historial: lo nuevo que se pidió/aceptó; el tooltip del ícono lleva el motivo. -->
                                <span class="new-value" [title]="row.is_history ? (row.history_reason || '') : (row.new_value_title || '')">{{ row.new_value }}<i class="fa fa-comment-o history-reason" *ngIf="row.is_history && row.history_reason" role="img" aria-label="Con motivo"></i></span>
                            </ng-template>
                        </ngx-datatable-column>
                        <!-- Respuesta MOBICO = estatus de lo que la fila muestra; el cambio en curso
                             va en color de revisión (naranja) para distinguirlo del pedido normal -->
                        <ngx-datatable-column prop="statusName" name="Respuesta MOBICO" [width]="170" [minWidth]="160" [sortable]="false"
                            [headerClass]="'top-side'">
                            <ng-template ngx-datatable-header-template><span>Respuesta<br />MOBICO</span></ng-template>
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="status-label"
                                    [ngClass]="{'status-confirmed': (row.event_status || row.status) === 'confirmed', 'status-rejected': (row.event_status || row.status) === 'rejected', 'status-review': (row.event_status || row.status) === 'review' || row.in_flight_change}"
                                    [title]="row.week_status || ''">
                                    {{ row.statusName || '—' }}
                                </span>
                                <!-- Llegó con poco aviso (regla MOBICO 48/24 hrs): el reloj ámbar es menos de 48 hrs
                                     (en espera de disponibilidad); el rojo, menos de 24 hrs (puede que no se atienda). -->
                                <i class="fa deadline-flag" *ngIf="row.deadline_state && row.in_flight_change"
                                    [ngClass]="row.deadline_state === 'late' ? 'fa-exclamation-triangle late' : 'fa-clock-o'"
                                    [title]="deadlineTitle(row)" aria-hidden="true"></i>
                                <!-- Aprobada con ajustes de MOBICO (otro producto / fecha / litros que los solicitados): el tooltip
                                     trae cada valor anterior y el motivo; el detalle completo está en el historial del pedido. -->
                                <i class="fa fa-sliders adjust-flag" *ngIf="row.adjustments?.length && !row.in_flight_change && !row.is_history"
                                    [title]="'Aprobada con ajustes de MOBICO\n\n' + adjustmentsTitle(row)" role="img" aria-label="Aprobada con ajustes de MOBICO"></i>
                            </ng-template>
                        </ngx-datatable-column>
                        <!-- Acciones de la solicitud: botones etiquetados con la pareja de botones
                             del portal (verde CTA / gris), igual que la tabla Solicitudes del
                             solicitante. minWidth evita que columnMode force comprima la columna
                             y corte los botones. -->
                        <!-- 250/240px: Rechazar · Aprobar · Cambiar en una línea (≈ 72 + 69 + 69 + aire + inset). -->
                        <ngx-datatable-column name="Acciones" [width]="250" [minWidth]="240" [sortable]="false"
                            [cellClass]="'right-side'" [headerClass]="'top-side right-side'">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <!-- Orden gris → verde (task 2026-07-13 "orden de acciones"):
                                     igual que los modales del flujo — secundaria primero,
                                     la principal (verde) al final. SIEMPRE visibles con
                                     enable/disable + tooltip del motivo (task 2026-07-14,
                                     mismo patrón que Cambiar/Cancelar del solicitante);
                                     solo historial y filas de relleno quedan en "—". -->
                                <ng-container *ngIf="!row.is_history && !row._placeholder; else noActions">
                                    <button type="button" class="row-action-btn gray"
                                        [disabled]="!isActionable(row)"
                                        [title]="isActionable(row) ? 'Rechazar la solicitud' : actionsDisabledReason(row)"
                                        (click)="rejectOrder(row)">Rechazar</button>
                                    <button type="button" class="row-action-btn green"
                                        [disabled]="!isActionable(row)"
                                        [title]="isActionable(row) ? 'Aprobar la solicitud' : actionsDisabledReason(row)"
                                        (click)="approveOrder(row)">Aprobar</button>
                                    <!-- Pedido ya aprobado: Rechazar/Aprobar siguen visibles (bloqueados) para que se vea que ya se
                                         respondió, y «Cambiar» abre el modal de aprobar con los valores vigentes por si hace
                                         falta mover algo (usuario, 16-oct; etiqueta corta 19-oct). Mismo botón en el Cronograma. -->
                                    <button type="button" class="row-action-btn green" *ngIf="canRequestChange(row)"
                                        title="Cambiar producto, fecha de entrega o litros de este pedido ya aprobado"
                                        (click)="openChange(row)">Cambiar</button>
                                </ng-container>
                                <ng-template #noActions><span class="mobico-response">—</span></ng-template>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>

            </ng-container>

            <div class="row" style="margin:10px;" *ngIf="reqst === 0">
                <app-table-loader style="width: 100%;"></app-table-loader>
            </div>
        </div>
    </div>
</div>

<!-- Modal de confirmación Aprobar/Rechazar: anatomía del custom-alert REAL del portal
     (header neutro, ícono auto-coloreado, título oscuro; el color vive en el ícono y
     en el botón primario). Botones como en todo el portal: gris cerrar, verde confirmar. -->
<!-- op-confirm--compact: sin datos de aceptación (aprobar cancelación / rechazar)
     el modal encoge a 520px; el formato de aprobación con campos no se toca. -->
<div class="modal fade op-modal op-confirm" [class.show]="!!confirmAction"
    [class.op-confirm--compact]="!!confirmAction && !confirmAction.needsDeliveryDate"
    [style.display]="confirmAction ? 'flex' : 'none'"
    tabindex="-1" role="dialog" aria-labelledby="confirmTitle" [attr.aria-hidden]="!confirmAction">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <!-- Ícono en círculo translúcido, como los custom-alert del portal
                     (palomita al aprobar, interrogación al rechazar). -->
                <!-- Azul MOBICO (Edey 15-oct): header blanco con el ícono en círculo
                     azul, como el modal de Inventario proyectado; antes era el verde del portal. -->
                <div class="confirm-icon" aria-hidden="true">
                    <i class="fa" [ngClass]="confirmAction?.status === 'confirmed' ? 'fa-check' : 'fa-question'"></i>
                </div>
                <h5 class="modal-title" id="confirmTitle">{{ confirmAction?.title }}</h5>
                <button type="button" class="close" aria-label="Cerrar" (click)="cancelConfirmAction()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="confirmAction">
                <!-- Sujeto protagonista (chip + PO + estación) y consecuencia en tenue -->
                <div class="confirm-subject">
                    <span class="type-chip" [ngClass]="confirmAction.row.change_kind">{{ confirmAction.row.type_label }}</span>
                    <span>PO {{ confirmAction.row.po_number || '—' }} · {{ confirmAction.row.station_name || '' }}</span>
                </div>
                <p class="confirm-value" *ngIf="confirmAction.row.new_value && confirmAction.row.new_value !== '—'">
                    Nuevo valor: <b>{{ confirmAction.row.new_value }}</b>
                </p>
                <p class="confirm-note deadline-note" [class.late]="confirmAction.row.deadline_state === 'late'"
                    *ngIf="confirmAction.row.deadline_state && confirmAction.row.in_flight_change">
                    <i class="fa" [ngClass]="confirmAction.row.deadline_state === 'late' ? 'fa-exclamation-triangle' : 'fa-clock-o'" aria-hidden="true"></i>
                    {{ deadlineTitle(confirmAction.row) }}
                </p>
                <!-- Datos de aceptación (al aprobar un pedido o un cambio; la cancelación
                     no los pide). TODOS opcionales (feedback 2026-07-13): el admin puede
                     aprobar sin capturarlos; solo bloquea una fecha capturada anterior a hoy
                     (confirmActionValid). Mobico puede aceptar una cantidad o fecha
                     distinta a la solicitada. Rejilla de 2 columnas dentro del modal. -->
                <div class="confirm-fields" *ngIf="confirmAction.needsDeliveryDate">
                    <!-- Producto (usuario, 16-oct): MOBICO puede aceptar otro que el solicitado; llega precargado con el pedido.
                         Si cambia, el PO pasa al del producto nuevo (el actual ya no se reutiliza). -->
                    <div class="confirm-field">
                        <label for="confirmProduct">Producto</label>
                        <select id="confirmProduct" class="form-control"
                            [ngModel]="confirmProduct" (ngModelChange)="confirmProduct = $event; refreshConfirmSpace()"
                            [ngModelOptions]="{standalone: true}">
                            <option *ngFor="let p of productOptions" [value]="p.value">{{ p.label }}</option>
                        </select>
                    </div>
                    <div class="confirm-field">
                        <label for="confirmDeliveryDate">Fecha de entrega</label>
                        <!-- Mini calendario custom (task 2026-07-13 "igual que el selector del
                             cambio de fecha"): input readonly que abre el op-mini-cal flotante
                             con la fecha SOLICITADA marcada en gris y la de entrega en verde.
                             El minDate del picker cubre el "no antes de hoy" (sin tecleo manual). -->
                        <input id="confirmDeliveryDate" type="text" class="form-control cal-input" readonly
                            placeholder="Selecciona la fecha"
                            [value]="confirmDeliveryDate ? (confirmDeliveryDate | date:'dd/MM/yy':'+0000':'es') : ''"
                            (click)="toggleDeliveryCalendar($event)">
                        <small class="confirm-field-error" *ngIf="deliveryDateTooEarly">
                            La fecha de entrega no puede ser anterior a hoy.
                        </small>
                    </div>
                    <div class="confirm-field">
                        <label for="confirmLiters">Litros aceptados</label>
                        <input id="confirmLiters" type="text" inputmode="numeric" class="form-control"
                            appThousands [decimals]="0"
                            [class.over-space]="confirmOverSpace"
                            [ngModel]="confirmLiters" (ngModelChange)="confirmLiters = $event"
                            [ngModelOptions]="{standalone: true}"
                            placeholder="Litros que Mobico acepta">
                        <!-- Candado de inventario (task 2026-07-15, ajuste: el hint vive BAJO
                             el campo de litros): verde = hay espacio, rojo = excede (Aprobar
                             disabled) y ES el botón del desglose "¿Por qué no hay espacio?",
                             gris = consultando o sin datos de tanque. -->
                        <small class="space-hint muted" *ngIf="confirmSpaceLoading">
                            <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                            Consultando espacio…
                        </small>
                        <small class="space-hint" [class.over]="confirmOverSpace"
                            *ngIf="!confirmSpaceLoading && confirmSpace != null"
                            (click)="confirmOverSpace && openConfirmSpaceInfo()"
                            [title]="confirmOverSpace
                                ? 'Ver por qué no hay espacio'
                                : confirmSpaceBasis === 'theoretical'
                                    ? 'Espacio a la fecha de entrega: capacidad del tanque menos inventario TEÓRICO del día (el mismo del Cronograma) y arrastre'
                                    : 'Espacio a la fecha de entrega: capacidad del tanque menos la lectura real del volumétrico y arrastre'">
                            <i class="fa" [ngClass]="confirmOverSpace ? 'fa-exclamation-triangle' : 'fa-tint'"
                                aria-hidden="true"></i>
                            <span>
                                <ng-container *ngIf="!confirmOverSpace">Espacio disp.
                                    {{ confirmSpace | number: "1.0-0" }} lts.</ng-container>
                                <ng-container *ngIf="confirmOverSpace && confirmSpace">Excede máx.
                                    {{ confirmSpace | number: "1.0-0" }} lts.</ng-container>
                                <ng-container *ngIf="confirmOverSpace && !confirmSpace">Sin espacio disponible</ng-container>
                                <i class="fa fa-question-circle space-hint__q" *ngIf="confirmOverSpace"
                                    aria-hidden="true"></i>
                            </span>
                        </small>
                        <!-- Aviso de capacidad (junta 27-oct): cabe, pero la siguiente capacidad de la estación ya no. -->
                        <small class="space-hint tight" *ngIf="!confirmSpaceLoading && confirmNextCapacityOver as nextCap">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            Una pipa de {{ nextCap | number: "1.0-0" }} ya no cabe
                        </small>
                        <small class="space-hint muted"
                            *ngIf="!confirmSpaceLoading && confirmSpaceChecked && confirmSpace == null"
                            title="La estación no tiene capacidad de tanque o lectura de inventario para este producto">
                            <i class="fa fa-tint" aria-hidden="true"></i>
                            Sin datos de tanque
                        </small>
                    </div>
                </div>
                <!-- Calendario de "Fecha de entrega" (réplica del op-mini-cal del cambio de
                     fecha, pipes.component): capa fija transparente que atrapa el click-fuera
                     + panel anclado al campo (calPanelPos, calculado al abrir). Fecha
                     SOLICITADA por la estación en gris (referencia, sí seleccionable: entregar
                     el día pedido es válido) y la fecha de entrega elegida en verde. -->
                <div class="op-cal-overlay" *ngIf="showDeliveryCalendar" (click)="showDeliveryCalendar = false">
                    <div class="op-mini-cal op-mini-cal--modal" [ngStyle]="calPanelPos" (click)="$event.stopPropagation()">
                        <ngb-datepicker
                            [startDate]="calStartDate"
                            [minDate]="calMinDate"
                            navigation="arrows"
                            [dayTemplate]="calDay"
                            [footerTemplate]="calFooter"
                            (dateSelect)="onCalSelect($event)"
                        ></ngb-datepicker>
                        <ng-template #calFooter>
                            <div class="cal-legend">
                                <span class="cal-dot current"></span> Fecha requerida
                                <span class="cal-dot selected"></span> Fecha de entrega
                            </div>
                        </ng-template>
                        <ng-template #calDay let-date let-currentMonth="currentMonth" let-disabled="disabled">
                            <span class="cal-day"
                                [class.cal-outside]="date.month !== currentMonth"
                                [class.cal-disabled]="disabled"
                                [class.cal-current]="isCalRequested(date)"
                                [class.cal-selected]="isCalSelected(date)">{{ date.day }}</span>
                        </ng-template>
                    </div>
                </div>
                <!-- Aprobar un cambio confirma también el pedido completo; el copy lo anuncia -->
                <p class="confirm-note" *ngIf="confirmAction.edit">
                    Se guardará el cambio sobre el pedido ya aprobado; la estación verá el valor anterior y el
                    nuevo en su historial.
                </p>
                <p class="confirm-note" *ngIf="!confirmAction.edit && confirmAction.status === 'confirmed' && confirmAction.row.in_flight_change">
                    Se aprobará el cambio y el pedido completo quedará confirmado;
                    la estación verá la respuesta en su portal.
                </p>
                <p class="confirm-note" *ngIf="!confirmAction.edit && !(confirmAction.status === 'confirmed' && confirmAction.row.in_flight_change)">
                    Se {{ confirmAction.status === 'confirmed' ? 'aprobará' : 'rechazará' }} esta solicitud
                    y la estación verá la respuesta en su portal.
                </p>
                <p class="confirm-error" *ngIf="confirmError">{{ confirmError }}</p>
            </div>
            <div class="modal-footer">
                <button class="confirm-btn gray" (click)="cancelConfirmAction()" [disabled]="respondingOrder">Cancelar</button>
                <button class="confirm-btn green" (click)="confirmRespond()" [disabled]="respondingOrder || !confirmActionValid">
                    {{ respondingOrder ? 'Guardando…' : confirmAction?.actionLabel }}
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show" *ngIf="confirmAction" (click)="cancelConfirmAction()"></div>


<!-- Modal informativo "¿Por qué no hay espacio?" (task 2026-07-15, réplica scoped
     del spaceInfo del solicitante — patrón de duplicación tipo op-mini-cal): desglose
     de la cuenta del candado del Aprobar. Solo lectura, un botón para cerrar. Va
     DESPUÉS del modal Aprobar en el DOM para pintarse encima. -->
<!-- op-confirm--compact: mismo ancho compacto (520px) que Rechazar/aprobar-cancelación
     y consistente con el desglose del solicitante; el ancho completo de 820px del
     Aprobar quedaba enorme para esta lista de 5 renglones. -->
<div class="modal fade op-modal op-confirm op-confirm--compact op-space-info" [class.show]="!!spaceInfo"
    [style.display]="spaceInfo ? 'flex' : 'none'" tabindex="-1" role="dialog"
    aria-labelledby="adminSpaceInfoTitle" [attr.aria-hidden]="!spaceInfo">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="confirm-icon" aria-hidden="true">
                    <img src="/assets/icons/alert-confirm.svg" alt="" width="26" height="26" />
                </div>
                <h5 class="modal-title" id="adminSpaceInfoTitle">¿Por qué no hay espacio?</h5>
                <button type="button" class="close" aria-label="Cerrar" (click)="closeSpaceInfo()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="spaceInfo">
                <div class="space-info">
                    <div class="space-info__row">
                        <span>Capacidad del tanque</span>
                        <b>{{ spaceInfo.tank != null ? (spaceInfo.tank | number: "1.0-0") + " lts." : "—" }}</b>
                    </div>
                    <div class="space-info__row">
                        <span>− Inventario {{ spaceInfo.basis === "real" ? "real" : "teórico" }}
                            {{ spaceInfo.invDate ? "al " + (spaceInfo.invDate | date: "dd/MM/yy" : "+0000" : "es") : "" }}</span>
                        <b>{{ spaceInfo.inventory != null ? (spaceInfo.inventory | number: "1.0-0") + " lts." : "—" }}</b>
                    </div>
                    <div class="space-info__row" *ngIf="spaceInfo.carry">
                        <span>− Arrastre del tanque</span>
                        <b>{{ spaceInfo.carry | number: "1.0-0" }} lts.</b>
                    </div>
                    <div class="space-info__row space-info__total">
                        <span>= Espacio disponible</span>
                        <b>{{ spaceInfo.available != null ? (spaceInfo.available | number: "1.0-0") + " lts." : "—" }}</b>
                    </div>
                    <div class="space-info__row space-info__requested" *ngIf="spaceInfo.requested != null">
                        <span>Litros aceptados</span>
                        <b>{{ spaceInfo.requested | number: "1.0-0" }} lts.</b>
                    </div>
                </div>
                <p class="confirm-note">
                    Ajusta los litros aceptados o la fecha de entrega para que la pipa quepa.
                </p>
            </div>
            <div class="modal-footer">
                <button class="confirm-btn green" (click)="closeSpaceInfo()">Entendido</button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show op-space-backdrop" *ngIf="spaceInfo" (click)="closeSpaceInfo()"></div>
